import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=6a73961c&scoped=true"
import script from "./setting.vue?vue&type=script&lang=ts"
export * from "./setting.vue?vue&type=script&lang=ts"
import style0 from "./setting.vue?vue&type=style&index=0&id=6a73961c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a73961c",
  null
  
)

export default component.exports